// extracted by mini-css-extract-plugin
module.exports = {"column":"FidAdminPrivileges_column__2i81Z","delete":"FidAdminPrivileges_delete__2tNah","confirmLabel":"FidAdminPrivileges_confirmLabel__2JDqE"};